export const assignationStatusFilter = {
  key: 'alkemics.assignation.status',
  query: 'assignation_status',
  isAvailable: () => true,
  withRefusedAssignation: 'withRefusedAssignation',
};
